module.exports = __webpack_public_path__ + "static/media/fundo.a8b92fcd.jpg";